<template>
  <svg viewBox="0 0 24 24" width="24" height="24" fill="currentColor">
    <path
      d="M22 19.4a1 1 0 0 1-1.2 1.1H3.1A1 1 0 0 1 2 19.4V4.6a1.1 1.1 0 1 1 2.2 0v9.2l4-4a1 1 0 0 1 1.6 0l2.2 2.1 4-4h-1a1.1 1.1 0 1 1 0-2.2h3.6a1 1 0 0 1 1.1 1.1v3.7a1.1 1.1 0 1 1-2.2 0v-1l-4.7 4.8a1 1 0 0 1-1.6 0L9 12l-4.8 4.8v1.4h16.6a1 1 0 0 1 1.2 1"
    />
  </svg>
</template>
